var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component } from 'vue-property-decorator';
import FormInput from '@/common/components/Form/FormInput.vue';
import FormModal from '@/common/components/Modal/FormModal.vue';
import { postBoothsBatch } from 'src/common/api/common';
import Draggable from 'vuedraggable';
var AddBoothModal = /** @class */ (function (_super) {
    __extends(AddBoothModal, _super);
    function AddBoothModal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.visible = false;
        _this.requesting = false;
        _this.formData = {
            boothNames: [],
        };
        return _this;
    }
    /* methods */
    AddBoothModal.prototype.init = function () {
        this.visible = true;
        this.formData.boothNames = [null];
    };
    AddBoothModal.prototype.addBoothItem = function () {
        this.formData.boothNames.push(null);
    };
    AddBoothModal.prototype.deleteBoothItem = function (index) {
        this.formData.boothNames.splice(index, 1);
    };
    AddBoothModal.prototype.submit = function () {
        var _this = this;
        this.$refs.formData.validate(function (valid) {
            if (!valid) {
                _this.$message({
                    type: 'error',
                    message: "\u4FE1\u606F\u672A\u586B\u5199\u5B8C\u6574\uFF0C\u8BF7\u68C0\u67E5",
                });
                return false;
            }
            else {
                _this.requesting = true;
                var params = Object.assign({}, _this.formData);
                postBoothsBatch(params).then(function () {
                    _this.$message.success('新建展位成功！');
                    _this.$store.commit('ADD_BOOTH', Date.now());
                    _this.visible = false;
                }).finally(function () {
                    _this.requesting = false;
                });
            }
        });
    };
    AddBoothModal = __decorate([
        Component({
            components: {
                FormInput: FormInput,
                FormModal: FormModal,
                Draggable: Draggable,
            },
        })
    ], AddBoothModal);
    return AddBoothModal;
}(Vue));
export default AddBoothModal;
